import React from 'react';

import { AnimatedCheckmark } from 'components/Icon/Icon';
import Spinner from 'components/Spinner';
import { useCurrentUser } from 'store/main/hooks';
import { colors } from 'theme';

type Props = {
  submitting: boolean;
  isSubscribed: boolean;
};

export function ContentPageSubscribed({ submitting, isSubscribed }: Props) {
  const currentUser = useCurrentUser();

  if (!currentUser || !currentUser.isLoaded || submitting) {
    return <Spinner size="small" label="Submitting" />;
  }

  return (
    <>
      {isSubscribed && (
        <AnimatedCheckmark mr="8px" stroke={colors.turtleGreen} />
      )}
      {isSubscribed ? getText('Subscribed!') : getText('Subscribe')}
    </>
  );
}
